<template>
  <div>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, minimum-scale=1"
    />
    <div v-if="$store.state.views.homepage.status === true">
      <Loader v-if="isLoading" />
      <div v-if="!isLoading">
        <homepage />
      </div>
    </div>

    <div v-if="$store.state.views.results.status === true">
      <Loader v-if="isLoading" />
      <div v-if="!isLoading">
        <results />
      </div>
    </div>

    <div
      v-if="
        $store.state.views.homepage.status !== true &&
        $store.state.views.results.status !== true
      "
    >
      <div
        :class="{
          questionBasicPage: questionBasicPageLayout,
          'md:mt-20': questionBasicPageLayout,
        }"
        class="md:border-grey-100 ml-auto mr-auto md:rounded-xxl"
      >
        <div class="topDivInfo dark:bg-hero-purple">
          <div style="padding: 0 20px">
            <div id="appHeader" class="topRowInfo" :style="{'display': showHeader }">
              <div class="section1">
                <div v-if="$store.state.darkMode">
                  <div class="newlogoDark"></div>
                </div>
                <div v-else>
                  <div class="newlogo"></div>
                </div>

                <div class="shieldMobile block sm:hidden"></div>
              </div>
              <div class="section2">
                <h1 class="section2Title dark:text-white">
                  Wellness Services Navigator
                </h1>
              </div>
              <div class="section1">
                <ExitButton />
                <div v-on:click="darkModeToggle()" class="cursor-pointer">
                  <div v-if="$store.state.darkMode">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="darkmodeHeader"
                    >
                      <path
                        d="M15.413 10.0217V8M15.413 23.5V21.4783M10.0795 21.6178L11.5091 20.1882M19.5143 11.5091L20.9439 10.0796M19.3169 20.1882L20.7465 21.6178M9.8821 10.0796L11.3117 11.5091M8 16.087H10.0217M21.4783 16.087H23.5"
                        stroke="white"
                        stroke-linecap="round"
                      />
                      <circle
                        cx="15.7501"
                        cy="15.75"
                        r="4.71739"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div v-else>
                    <svg
                      class="darkmodeHeader"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M23.9737 18.4014C24.0936 18.1359 23.7791 17.8967 23.5224 18.0367C22.5324 18.5766 21.3956 18.8837 20.1866 18.8837C16.3514 18.8837 13.2423 15.7934 13.2423 11.9814C13.2423 10.7043 13.5913 9.50814 14.1997 8.48209C14.3483 8.2314 14.1174 7.91173 13.8467 8.02263C11.0022 9.18811 9 11.9713 9 15.2192C9 19.5164 12.5048 23 16.8281 23C20.0108 23 22.7499 21.1121 23.9737 18.4014Z"
                        fill="#3F3D56"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <hr class="hrDividerTop" /> -->
          <ProgressBar />
        </div>

        <div v-if="$store.state.views.questionOne.status === true">
          <Q1 />
        </div>

        <div v-if="$store.state.views.questionTwo.status === true">
          <Q2 />
        </div>
        <div v-if="$store.state.views.questionTen.status === true">
          <Q10 />
        </div>

        <div v-if="$store.state.views.questionThree.status === true">
          <Q3 />
        </div>

        <div v-if="$store.state.views.questionFour.status === true">
          <Q4 />
        </div>
        <div v-if="$store.state.views.questionFive.status === true">
          <Q5 />
        </div>
        <div v-if="$store.state.views.questionSix.status === true">
          <Q6 />
        </div>
        <div v-if="$store.state.views.questionSeven.status === true">
          <Q7 />
        </div>
        <div v-if="$store.state.views.questionEight.status === true">
          <Q8 />
        </div>
        <div v-if="$store.state.views.questionNine.status === true">
          <Q9 />
        </div>

        <div class="mobileViewHide">
          <QuestionFooter />
        </div>

      </div>

    </div>

  </div>
</template>

<script>
//import HelpDialog from "./components/HelpDialog.vue";
import ProgressBar from "./components/ProgressBar.vue";
import ExitButton from "./components/ExitButton.vue";
import QuestionFooter from "./components/QuestionFooter.vue";
import Q1 from "./components/Q1.vue";
import Q2 from "./components/q2.vue";
import Q3 from "./components/q3.vue";
import Q4 from "./components/q4.vue";
import Q5 from "./components/q5.vue";
import Q6 from "./components/q6.vue";
import Q7 from "./components/Q7.vue";
import Q8 from "./components/Q8.vue";
import Q9 from "./components/Q9.vue";
import Q10 from "./components/Q10.vue";
import results from "./components/resultsPage.vue";
import homepage from "./components/startPage.vue";
//import Logo from "./components/Logo.vue";
import store from "./store";
import { mapState } from "vuex";
import Loader from "./components/Loader.vue";
export default {
  name: "App",
  components: {
    // Logo,
    homepage,
    Q1,
    Q2,
    Q3,
    Q4,
    Q5,
    Q6,
    Q7,
    Q8,
    Q9,
    Q10,
    results,
    // HelpDialog,
    ProgressBar,
    Loader,
    QuestionFooter,
    ExitButton,
  },
  data() {
    return {
      isLoading: true,
      results: [],
      viewMode: "full",
      questionBasicPageLayout: false,
      questionBasicPageFull: false,
      darkSide: false,
      showHeader: "flex"
    };
  },
  methods: {
    loaderr() {
      this.isLoading = false;
    },

    checkDisplayMode() {
      if (localStorage.theme === "dark") {
        document.documentElement.classList.add("dark");
        this.darkSide = true;
        store.commit("changeDarkMode", this.darkSide);
      } else {
        document.documentElement.classList.remove("dark");
        this.darkSide = false;
        store.commit("changeDarkMode", this.darkSide);
      }
    },

    darkModeToggle() {
      store.commit("changeDarkModeSwap");
      const currMode = store.getters.darkModeState;
      this.darkSide = !this.darkSide;
      let classClass = "";
      if (currMode) {
        classClass = "dark";
        localStorage.theme = "dark";
      } else {
        classClass = "";
        localStorage.removeItem("theme");
      }
      var root = document.getElementsByTagName("html")[0];
      root.setAttribute("class", classClass);
    },
    checkDisplay() {
      window.addEventListener("resize", function () {
        var w = document.documentElement.clientWidth;
        //var h = document.documentElement.clientHeight;
        //console.log(w);
        if (w <= 640) {
          this.questionBasicPageLayout = true;
        } else {
          this.questionBasicPageLayout = false;
        }
      });
    },
    checkStyleLoader() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get('view') === "app") {
        this.showHeader = "none";
      }
    }
  },
  mounted() {
    this.$store.dispatch("loadServices");

    this.checkDisplayMode();
    this.loaderr();
    this.checkDisplay();
    this.checkStyleLoader();
    // this.checkDarkModeStatus();

    // var scrollEventHandler = function () {
    //   window.scroll(0, window.pageYOffset);
    // };

    // window.addEventListener("scroll", scrollEventHandler, false);
  },

  computed: mapState(["services"]),
};
</script>

<style></style>
